import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import Table from 'antd/es/table';
import "antd/es/table/style/index.css";
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import _ from 'lodash';

class TableDateBusiness extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectRow: '',
            sort: 'ASC',
            classSort: 'descending sorted',
            headerClick: '',
            totalOTByDate: [],
            data: {}
        }
    }

    componentWillMount() {
        const { dataList, totalOTDate } = this.props;
        this.setState({
            dataList: dataList || {},
            totalOTByDate: totalOTDate || []
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.unSelectRow !== true) {
            this.setState({
                selectRow: ''
            })
        }

        if (nextProps.defaultSort && nextProps.defaultSort.indexOf("ASC") !== -1) {
            this.setState({
                sort: 'ASC',
                classSort: 'descending sorted',
                headerClick: ''
            })
        }

        this.setState({
            dataList: nextProps.dataList || {},
            totalOTByDate: nextProps.totalOTDate || []
        })
    }

    // handle row click
    handleRowClick = (val) => {
        this.setState({ selectRow: val['projectId'] });
        this.props.onRowClick(val);
    }

    // handle click Sort
    handleSort = async (val) => {
        await (this.state.sort === 'ASC') ? (this.setState({
            sort: 'DESC',
            classSort: 'ascending sorted',
            headerClick: val
        })) : (
                this.setState({
                    sort: 'ASC',
                    classSort: 'descending sorted',
                    headerClick: val
                })
            );

        return this.props.sortBy(this.state.headerClick + '-' + this.state.sort);
    }

    checkStatus = (checkValue) => {
        let status = '';

        if (this.props.listCheckStatus !== undefined) {
            this.props.listCheckStatus.map((subItem) => {
                if (checkValue !== undefined && checkValue.indexOf(subItem.date) === 0) {
                    if (subItem['checkStatus']) {
                        status = 'day-approved';
                    }
                }
            })
        }

        return status;
    }

    render() {
        const { dataList } = this.state;
        const { tableStructure, t } = this.props;

        // Set Structure table 
        const columns = _.map(tableStructure, (state, index) => ({
            title: !state.isDate ? t(state['label']) : state['label'],
            dataIndex: 'data' + index,
            key: 'data' + index,
            className: this.checkStatus(state.checkValue) + ' ' + (state.isClass ? state.isClass : ''),
            fixed: state['fixed'] ? state['fixed'] : '',
            width: index === 0 ? 105 : 70
        }))

        // Set data table
        let dataFrom = {};
        let dataTo = {};
        let dataSide = {};
        _.map(tableStructure, (state, index) => {
            if (index === 0) {
                dataFrom['data' + index] =  t('labels.businessFrom');
                dataTo['data' + index] =  t('labels.businessTo');
                dataSide['data' + index] =  t('labels.site');
            } else {
                dataFrom['data' + index] = dataList[String("0" + index).slice(-2)] && dataList[String("0" + index).slice(-2)]['businessFrom'] ? 
                dataList[String("0" + index).slice(-2)]['businessFrom'] : '';

                dataTo['data' + index] = dataList[String("0" + index).slice(-2)] && dataList[String("0" + index).slice(-2)]['businessTo'] ? 
                dataList[String("0" + index).slice(-2)]['businessTo'] : '';

                dataSide['data' + index] = dataList[String("0" + index).slice(-2)] && dataList[String("0" + index).slice(-2)]['site'] ? 
                <Checkbox readOnly checked={dataList[String("0" + index).slice(-2)]['site'] == 1 ? true : false} /> : <Checkbox readOnly checked={false}/>
               
            }
        })

        const data = [dataFrom, dataTo, dataSide];
        return (
            <div className="table-list">
                <Table 
                    bordered
                    dataSource={data} 
                    columns={columns} 
                    scroll={{ x: 1170 }}
                    pagination={false} 
                    className="table-bussiness"
                />  
            </div>
        );
    }
}

export default compose(
    withTranslation(),
)(TableDateBusiness);
